module.exports = __webpack_public_path__ + "img/coupon_200.2e81253c.png";